import { calcStringByteLength } from "flavr-common";
export function calcFileIdByteLength(fileId) {
    if (typeof fileId === "number") {
        return Uint32Array.BYTES_PER_ELEMENT;
    }
    return calcStringByteLength(fileId);
}
export function serializationFileId(stream, fileId) {
    if (typeof fileId === "number") {
        return stream.uint32(fileId);
    }
    return stream.utf16String(fileId);
}
